import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-pagina-alerta" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ss-imagem-pagina-alerta",
    src: "/static/img/ilustracoes/ambiente-nao-encontrado.svg"
  })
], -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_5 = { class: "ss-mensagem-pagina-alerta" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Cadê? não encontramos seu ambiente de trabalho!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Sua chave de parceiro pode estar incorreta ou ainda estamos terminando de construir o ambiente para você!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Espere um momento e tente novamente, caso esse problema persista por favor entre em contato com nosso suporte ou um de nossos consultores. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-pagina-alerta",
  style: {},
  target: "_blank",
  href: "https://atendimento.sabresistemas.com.br/"
}, "Suporte", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-pagina-alerta",
  target: "_blank",
  href: "https://sabresistemas.com.br/fale-com-consultor/"
}, "Consultor", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              class: "ant-btn ant-btn-lg ant-btn-primary ss-botao-pagina-alerta",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.voltar && _ctx.voltar(...args)))
            }, "Voltar"),
            _hoisted_8,
            _hoisted_9
          ])
        ])
      ])
    ])
  ]))
}